import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import TransportToManufacturingTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import transportIcon from "../../../../../assets/new-product-detail-cats/sub-icons/product-transport-icon.svg";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const TransportToManufacturing = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("TRANSPORT_TO_MANUFACTURING") || "Transport to Manufacturing Site"}
        subDescription={t("TRANSPORT_TO_MANUFACTURING_DESC") || "Transportation of materials and products to the manufacturing site."}
        isNormal={true}
        number={"32.1"}
        icon={transportIcon}
      />

      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`transport-to-manufacturing-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <TransportToManufacturingTable productId={productId} />
        </TableLoadingWrapper>
      )}

      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default TransportToManufacturing;
